module.exports = __webpack_public_path__ + "static/media/request.1395b764.svg";